import { render, staticRenderFns } from "./ServerList.vue?vue&type=template&id=498fd0b8&scoped=true&"
import script from "./ServerList.vue?vue&type=script&lang=js&"
export * from "./ServerList.vue?vue&type=script&lang=js&"
import style0 from "./ServerList.vue?vue&type=style&index=0&id=498fd0b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498fd0b8",
  null
  
)

export default component.exports